export default {
  SET_CUSTOMER_PROPERTIES: 'setCustomerProperties',
  SET_SELECTED_CUSTOMER_PROPERTY: 'setSelectedCustomerProperty',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal'
}